import React, { useRef, useState } from 'react'
import "./Home.css"
import 'react-slideshow-image/dist/styles.css'
import {Slide} from "react-slideshow-image";
import styles from "./Home.css";
import slide1 from "../../slike/slide8.png";
import pipe1 from "../../slike/pipe1.png";
import slika2 from "../../slike/ADSSADAS.png";
import slika3 from "../../slike/PIPE.png";
import slika4 from "../../slike/2.png";
import { useNavigate } from 'react-router-dom';
import leantube from "../../slike/leantube2.png";
import heavy from "../../slike/heavy.png";
import aluminium from "../../slike/aluminium5.png";

export default function Home() {
const navigate=useNavigate();
const productPage = (name)=>{
  navigate("product/"+name);
}
const [currectSlide,setCurrentSlide] = useState(0);
const slideImages=[slide1,aluminium,slide1,slide1];
const products=[
  {slika:pipe1,naslov:"KARAKURI SYSTEM",link:"/"},
  {slika:slika2,naslov:"SQUARE PROFILES",link:"/"},
  {slika:slika3,naslov:"LEAN TUBE SYSTEM",link:"/"},
  {slika:slika4,naslov:"HEAVY SQUARE TUBE SYSTEM",link:"/"}
]
const slideRef = useRef(null);
return ( 
    <div className="home">
      <div className='telefon'>
      <div className={styles.container}>
        <Slide ref={slideRef}  easing="ease"duration={5000} autoplay={true} onChange={(oldIndex,newIndex)=>{setCurrentSlide(newIndex)}}>
          {slideImages.map((slide, index) => {
            return (
              <div className={styles.slide} key={slide} style={{backgroundImage: `url(${slide})`,
              backgroundSize: 'cover',
              backgroundPosition: 'center',
              width: '100%',            
              height: "300px",
              position:"relative",
              zIndex:6  }}>
                {index===0 &&(
                  <>
                    <img className={`pipe1 ${index === currectSlide? 'animate' : ''}`} src={pipe1} alt="nema slike :("/>
                    <div className={`tekst1 ${index === currectSlide? 'animate' : ''}`}>
                      <p className='podnaslov1'>Aluminium profiles for</p>
                      <p className='naslov1'>KARAKURI SYSTEM</p>
                      <button onClick={() => slideRef.current.goNext()}>Next</button>
                    </div>
                  </>
                )}
                {index===1 &&(
                  <>
                    <div className={`tekst1 ${index === currectSlide? 'animate' : ''}`}>
                      <p className='podnaslov1'>Aluminium</p>
                      <p className='naslov1'>SQUARE PROFILES</p>
                      <button onClick={() => slideRef.current.goNext()}>Next</button>
                    </div>
                  </>
                )}
                {index===2 &&(
                  <>
                    <img className={`pipe1 ${index === currectSlide? 'animate' : ''}`} src={leantube} alt="nema slike :("/>
                    <div className={`tekst1 ${index === currectSlide? 'animate' : ''}`}>
                      <p className='podnaslov1'></p>
                      <p className='naslov1'>LEAN TUBE SYSTEM</p>
                      <button onClick={() => slideRef.current.goNext()}>Next</button>
                    </div>
                  </>
                )}
                {index===3 &&(
                  <>
                    <img className={`pipe1 ${index === currectSlide? 'animate' : ''}`} src={heavy} alt="nema slike :("/>
                    <div className={`tekst1 ${index === currectSlide? 'animate' : ''}`}>
                      <p className='podnaslov1'>Heavy Square</p>
                      <p className='naslov1'>TUBE SYSTEM</p>
                      <button onClick={() => slideRef.current.goNext()}>Next</button>
                    </div>
                  </>
                )}
              </div>
            );
          })}
        </Slide>
      </div>
      </div>
      <div className='homeC'>
          <p>Home</p>
      </div>
      <div className='productsContainer'>
        <p className='h2'>PRODUCT RANGE</p>
      </div>
      <div className='s'>
        {products.map((item,index)=>(
            <div className='okvir' onClick={()=>{productPage(item.naslov)}}>
              <div className='productBox'>
                <img src={item.slika} className='slika' alt='slika'/>
              </div>
              <p>{item.naslov}</p>
          </div>
          ))}
      </div>
    </div>
 );
}
